module.exports = __webpack_public_path__ + "static/img/行业特性应用4.48f19c12.png";